import { Controller } from '@hotwired/stimulus'

export default class PerfilController extends Controller {
  static targets = ['content', 'verMas']

  tabClick (e) {
    const tabSeleccionada = e.detail
    const url = this.buildVerMasURL(tabSeleccionada, this.reiniciaPagina())

    this.informarEspera('Cargando')

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        this.contentTarget.innerHTML = responseText

        this.reiniciaPagina()
        this.desinformarEspera()

        window.history.replaceState({}, '', this.buildHistoryURL(tabSeleccionada))
      })
  }

  verMasClick () {
    const tabSeleccionada = this.verMasTarget.dataset.tab
    const url = this.buildVerMasURL(tabSeleccionada, this.siguientePagina())

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        this.verMasTarget.remove()
        this.contentTarget.insertAdjacentHTML('beforeend', responseText)
      })
  }

  //
  // Private
  //

  informarEspera (texto) {
    this.contentTarget.dataset.loading = texto
  }

  desinformarEspera () {
    delete this.contentTarget.dataset.loading
  }

  buildHistoryURL (tabSeleccionada) {
    const url = this.basePerfilURL()

    if (tabSeleccionada !== 'resumen') {
      url.pathname += '/' + tabSeleccionada
    }

    url.search = ''

    return url
  }

  buildVerMasURL (tabSeleccionada, pagina) {
    const url = this.basePerfilURL()

    url.pathname += '/ver-mas/' + tabSeleccionada
    url.search = `?page=${pagina}`

    return url
  }

  basePerfilURL () {
    const url = new URL(location)

    url.pathname = url.pathname.match(/(\/usuarios\/[\w-]+)/)[0]

    return url
  }

  reiniciaPagina () {
    this.data.set('pagina', 1)

    return 1
  }

  siguientePagina () {
    this.data.set('pagina', parseInt(this.data.get('pagina')) + 1)

    return this.data.get('pagina')
  }
}
